import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store';

import { deriveDateRange } from '~libs/dayjs';

// Export all selectors from the users module
export * as users from './users';

const WeeklyPlannerState = (state: RootState) => state.weeklyPlanner.weeklyPlanner;

export const selectOptions = (state: RootState) => WeeklyPlannerState(state).options;
export const selectParams = (state: RootState) => WeeklyPlannerState(state).params;

export const selectPlannerAPIOptions = createSelector(
  [selectOptions],
  ({ showBreaks, showTravel, showTeaBreaks, showCancellations, showPayableCancellations, showSystemUsers }) => ({
    travel: showTravel,
    breaks: showBreaks,
    tea_break: showTeaBreaks,
    show_cancellations: showCancellations,
    show_payable_cancellations: showPayableCancellations,
    show_system_users: showSystemUsers,
  }),
);

export const selectPreviousViewType = (state: RootState) => WeeklyPlannerState(state).previousViewType;

export const selectOpenAppointmentDetailsId = (state: RootState) => WeeklyPlannerState(state).openAppointmentDetailsId;
export const selectOpenAppointmentRosteringNotesId = (state: RootState) =>
  WeeklyPlannerState(state).openAppointmentRosteringNotesId;
export const selectFocusedAppointment = (state: RootState) => WeeklyPlannerState(state).focused;
export const selectFocusOptions = (state: RootState) => WeeklyPlannerState(state).focusOptions;
export const selectOrderBy = (state: RootState) => WeeklyPlannerState(state).orderBy;
export const selectPublishDate = (state: RootState) => WeeklyPlannerState(state).publishDate;
export const selectFocusedWorkerId = (state: RootState) => WeeklyPlannerState(state).focusedWorkerId;
export const selectImportedAppointments = (state: RootState) => WeeklyPlannerState(state).importedAppointments;
export const selectSearchParams = (state: RootState) => WeeklyPlannerState(state).searchParams;

export const selectDate = (state: RootState) => selectParams(state)?.date;
export const selectViewType = (state: RootState) => selectParams(state)?.viewType;
export const selectRangeType = (state: RootState) => selectParams(state)?.rangeType;

export const selectDerivedDateRange = createSelector([selectDate, selectRangeType], (date, rangeType) =>
  deriveDateRange(date, rangeType),
);

export const selectDerivedWeekRange = createSelector([selectDate], (date) => deriveDateRange(date, 'Weekly'));

export const selectShowSystemUsers = (state: RootState) => WeeklyPlannerState(state).options.showSystemUsers;
